import Footer from "../../FrontPage/components/Footer/Footer";
import NewHeader from "../../FrontPage/LandingPage/HeaderComponent/Header";
import VerifyUserForm from "../component/verifyUser/VerifyUser";
const VerifyUser = () => {
  return (
    <div>
      <NewHeader />
      <VerifyUserForm />
      <Footer />
    </div>
  );
};

export default VerifyUser;
